import { Group } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';
import { NavLink, NavLinkRenderProps } from 'react-router-dom';

import Text from 'components/shared/Text';
import { useLkLayoutStore } from 'stores/local/layout/LkLayoutStore';
import { useDevices } from 'utils/devices';

import s from './MenuItem.module.scss';

export type NavLinkConfig = {
  label: string;
  Icon: React.ElementType;
  to: string;
};

export type MenuItemProps = NavLinkConfig & {
  collapsed?: boolean;
};

const getClassName = ({ isActive }: NavLinkRenderProps) => {
  return cn(s.root, isActive && s.root_active);
};

export const MenuItem: React.FC<MenuItemProps> = ({ label, Icon, to, collapsed = false }) => {
  const { isPhone } = useDevices();
  const { menu } = useLkLayoutStore();

  const clickHandler = React.useCallback(() => {
    if (isPhone) {
      menu.close();
    }
  }, [isPhone, menu]);

  return (
    <NavLink className={getClassName} to={to} onClick={clickHandler} end>
      <Group gap={8} wrap="nowrap">
        <Icon size={20} />
        {!collapsed && (
          <Text size="xs" fw={600}>
            {label}
          </Text>
        )}
      </Group>
    </NavLink>
  );
};

export default React.memo(MenuItem);
